export default __webpack_public_path__ + "static/media/swordHero.b43677d5.jpg";